// extracted by mini-css-extract-plugin
export default {"social-medias":"SocialMedias_social-medias__9GWEb","social-media-wrapper":"SocialMedias_social-media-wrapper__VnC19","social-media":"SocialMedias_social-media__ttRNC"};